import type { Dayjs } from "@calcom/dayjs";
import dayjs from "@calcom/dayjs";
import type { EventBusyDate } from "@calcom/types/Calendar";

type SlotWithTime = {
  time: string;
  away?: boolean;
};

type SlotsByDate<TSlot extends SlotWithTime> = Record<string, TSlot[]>;

const timesOverlap = ({
  start,
  end,
  busyStart,
  busyEnd,
}: {
  start: Dayjs;
  end: Dayjs;
  busyStart: Dayjs;
  busyEnd: Dayjs;
}): boolean => start.isBefore(busyEnd) && end.isAfter(busyStart);

export const doesSlotOverlapOverlayBusyDates = ({
  slotTime,
  selectedDuration,
  overlayBusyDates,
}: {
  slotTime: string;
  selectedDuration: number | null;
  overlayBusyDates?: EventBusyDate[];
}): boolean => {
  if (!selectedDuration || !overlayBusyDates?.length) return false;

  const start = dayjs(slotTime);
  const end = start.add(selectedDuration, "minute");

  return overlayBusyDates.some((busyDate) =>
    timesOverlap({
      start,
      end,
      busyStart: dayjs(busyDate.start),
      busyEnd: dayjs(busyDate.end),
    })
  );
};

export const filterSlotsByOverlayAvailability = <TSlot extends SlotWithTime>({
  slots,
  selectedDuration,
  overlayBusyDates,
}: {
  slots?: SlotsByDate<TSlot>;
  selectedDuration: number | null;
  overlayBusyDates?: EventBusyDate[];
}): SlotsByDate<TSlot> | undefined => {
  if (!slots || !selectedDuration || !overlayBusyDates?.length) return slots;

  return Object.entries(slots).reduce<SlotsByDate<TSlot>>((filteredSlots, [date, daySlots]) => {
    filteredSlots[date] = daySlots.filter((slot) => {
      if (slot.away) return true;

      return !doesSlotOverlapOverlayBusyDates({
        slotTime: slot.time,
        selectedDuration,
        overlayBusyDates,
      });
    });

    return filteredSlots;
  }, {});
};
